/*------------------------------------------------
// File Name:HSM_UNIONPAY.js
// File Description:HSM_UNIONPAY API方法js接口
// Author:zxl
// Create Time:2022/07/15 14:28:44
//------------------------------------------------*/
import { axios } from '@/utils/request'

const api = {
   _unionpay: "/HSM_UNIONPAY"
}

export default api




//-------------------分页获取列表---------------
export function GetHSM_UNIONPAYListByPage(parameter) {
    return axios({
        url: api._unionpay + "/GetHSM_UNIONPAYListByPage",
        method: 'post',
        data: parameter
    })
}

//-------------------大后台-查询订单状态---------------
export function GetPayState(parameter) {
    return axios({
        url: api._unionpay + "/GetPayState",
        method: 'post',
        data: parameter
    })
}

//-------------------大后台-退款---------------
export function SetBackState(parameter) {
    return axios({
        url: api._unionpay + "/SetBackState",
        method: 'post',
        data: parameter
    })
}

